interface KeyboardShortcutProps {
  keys: string[];
}

export function KeyboardShortcut({ keys }: KeyboardShortcutProps) {
  return (
    <span className="inline-flex items-center gap-1">
      {keys.map((key, i) => (
        <span key={i} className="inline-flex items-center">
          {i > 0 && <span className="text-slate-400 mx-0.5">+</span>}
          <kbd className="inline-flex items-center justify-center min-w-[1.5rem] h-6 px-1.5 text-xs font-medium text-slate-600 bg-slate-100 border border-slate-300 rounded shadow-sm">
            {key}
          </kbd>
        </span>
      ))}
    </span>
  );
}
